import './PersonCard.scss'
import React from 'react'
import entityIcon from './entity-icon-2.png'
import personIcon from './person-icon-2.png'
import { camelizerHelper } from '../../../../helpers'
import { Col, Icon, Row, Button, Tooltip } from 'antd'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

const PersonCard = ({ currentUser, onClick, onClickAddRegister, showAddRegister, person }) => {
  const { t } = useTranslation()
  const authSearchModule = currentUser.cliente.modules.includes('AUTH-SEARCH') && currentUser.modules && !currentUser.modules.includes('OFCTO')
  const hasCertificado = (person.certificados?.length > 0 || person.hasPdf === true || person.compliance) && (!authSearchModule || person.status === 'APROBADO')

  const onClickLocal = () => {
    if (hasCertificado) {
      onClick(person, person.id, person.name, person.formatRut, person.type)
    }
  }

  const handleAddRegisterClick = (e) => {
    e.stopPropagation()
    onClickAddRegister(person)
  }

  const handleCertificateClick = (e) => {
    e.stopPropagation()
    onClickLocal()
  }

  const getStatusBadgeClass = () => {
    if (person.resultados === 0 || person.status === 'APROBADO') return 'query-risk-card__badge query-risk-card__badge--success'
    if (person.status === 'RECHAZADO') return 'query-risk-card__badge query-risk-card__badge--rejected'
    if (person.resultados > 1) return 'query-risk-card__badge query-risk-card__badge--warning'
    return 'query-risk-card__badge query-risk-card__badge--pending'
  }

  const getStatusBadgeLabel = () => {
    if (person.resultados === 0) return '✓ ' + t('messages.aml.searches.status.NO_MATCH')
    if (person.resultados > 1) return t('messages.aml.searches.status.TOO_MATCH')
    if (person.status === 'APROBADO') return '✓ ' + t('messages.aml.searches.status.APROBADO')
    if (person.status === 'PENDIENTE') return '... ' + t('messages.aml.searches.status.PENDIENTE')
    if (person.status === 'RECHAZADO') return '✗ ' + t('messages.aml.searches.status.RECHAZADO')
    return ''
  }

  const colIdentity = authSearchModule ? 5 : 6
  const colCompliance = authSearchModule ? 5 : 6
  const colStatus = authSearchModule ? 4 : null
  const colDate = authSearchModule ? 4 : 5
  const colActions = authSearchModule ? 6 : 7

  return (
    <div
      className={"query-risk-card"}
    >
      <Row type="flex" align="middle" className="query-risk-card__row">
        <Col xs={ colIdentity } className="query-risk-card__col query-risk-card__col--identity">
          <div className="query-risk-card__avatar">
            <img
              className="query-risk-card__avatar-icon"
              src={ person.type === 'Entity' ? entityIcon : personIcon }
              alt=""
            />
          </div>
          <div className="query-risk-card__identity-text">
            <span className="query-risk-card__name">{ camelizerHelper(person.name) || person.formatRut }</span>
            { person.name && <span className="query-risk-card__rut">{ person.formatRut }</span> }
          </div>
        </Col>

        <Col xs={ colCompliance } className="query-risk-card__col query-risk-card__col--compliance">
          <div className="query-risk-card__metric">
            <span className="query-risk-card__metric-label">{ t('messages.aml.compliance.PEPSAN') }</span>
            <span className={ 'query-risk-card__metric-value risk-' + (person.compliance?.PEPSAN?.color || 'GREEN') + (person.compliance?.PEPSAN?.bases === null ? ' is-disabled' : '') }>
              { person.compliance?.PEPSAN?.bases !== null ? person.compliance?.PEPSAN?.bases.length : <Icon type="lock" /> }
            </span>
          </div>
          <div className="query-risk-card__metric">
            <span className="query-risk-card__metric-label">KYC</span>
            <span className={ 'query-risk-card__metric-value risk-' + (person.compliance?.KYCAME?.color || 'GREEN') + (person.compliance?.KYCAME?.bases === null ? ' is-disabled' : '') }>
              { person.compliance?.KYCAME?.bases !== null ? person.compliance?.KYCAME?.bases.length : <Icon type="lock" /> }
            </span>
          </div>
          <div className="query-risk-card__metric">
            <span className="query-risk-card__metric-label">UBO</span>
            <span className={ 'query-risk-card__metric-value risk-' + (person.compliance?.UBOCOM?.color || 'GREEN') + (person.compliance?.UBOCOM?.bases === null ? ' is-disabled' : '') }>
              { person.compliance?.UBOCOM?.bases !== null ? person.compliance?.UBOCOM?.bases.length : <Icon type="lock" /> }
            </span>
          </div>
        </Col>

        { authSearchModule &&
          <Col xs={ colStatus } className="query-risk-card__col query-risk-card__col--status">
            <Tooltip title={ (person.status === 'APROBADO' || person.status === 'RECHAZADO') && person.msg111 }>
              <span className={ getStatusBadgeClass() }>{ getStatusBadgeLabel() }</span>
            </Tooltip>
          </Col>
        }

        <Col xs={ colDate } className="query-risk-card__col query-risk-card__col--date">
          <span className="query-risk-card__date">
            { moment(person?.creationDate).format('DD/MM/YYYY HH:mm') }
          </span>
        </Col>

        <Col xs={ colActions } className="query-risk-card__col query-risk-card__col--actions">
          { hasCertificado &&
            <Button
              size="small"
              className="query-risk-card__action query-risk-card__action--cert"
              onClick={ handleCertificateClick }
            >
              <span className="query-risk-card__action-text">{ t('messages.aml.viewCertificate') }</span>
              <Icon type="file-pdf" />
            </Button>
          }
          { showAddRegister &&
            <Button
              size="small"
              className="query-risk-card__action query-risk-card__action--register"
              onClick={ handleAddRegisterClick }
            >
              <span className="query-risk-card__action-text">{ t('messages.aml.addToClientsList') }</span>
              <Icon type="plus-circle" />
            </Button>
          }
        </Col>
      </Row>
    </div>
  )
}

export default PersonCard
